import React from "react";

function LoadingStatus() {
  return (
    <div className="container mx-auto p-6">
      <div className="flex flex-col items-center justify-center gap-3 min-h-[400px]">
        <div className="animate-spin rounded-full h-9 w-9 border-2 border-border border-t-primary" />
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    </div>
  );
}

export default LoadingStatus;
